"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaSimpleLiveCard = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _Card = require("../../atoms/Card");

var _DomestikaLiveCardInfo = require("../../atoms/DomestikaLiveCardInfo");

var _DomestikaLiveCardSkeleton = require("../../atoms/DomestikaLiveCardSkeleton");

var _Layout = require("../../atoms/Layout");

var _When = _interopRequireDefault(require("../../utils/When"));

var _validate = require("./validate");

var StyledCard = (0, _styledComponents.default)(_Card.Card).withConfig({
  displayName: "DomestikaSimpleLiveCard__StyledCard",
  componentId: "sc-1fbi0m0-0"
})((0, _css.default)({
  padding: '0',
  cursor: 'pointer'
}), (0, _styledSystem.variant)({
  prop: 'loading',
  variants: {
    true: {
      cursor: 'default'
    }
  }
}));

var DomestikaSimpleLiveCard = function DomestikaSimpleLiveCard(_ref) {
  var liveInfo = _ref.liveInfo,
      loading = _ref.loading,
      onClick = _ref.onClick,
      width = _ref.width,
      height = _ref.height,
      props = (0, _objectWithoutProperties2.default)(_ref, ["liveInfo", "loading", "onClick", "width", "height"]);

  if (!loading) {
    (0, _validate.validate)({
      liveInfo: liveInfo,
      onClick: onClick
    });
  }

  return _react.default.createElement(StyledCard, (0, _extends2.default)({
    onClick: onClick,
    boxShadow: "small",
    borderRadius: 3,
    width: width,
    height: height,
    loading: loading ? 'true' : 'false'
  }, props), _react.default.createElement(_When.default, {
    condition: !!loading
  }, function () {
    return _react.default.createElement(_Layout.Flex, {
      padding: [4, 4, 5]
    }, _react.default.createElement(_DomestikaLiveCardSkeleton.DomestikaLiveCardSkeleton, {
      type: "basic"
    }));
  }), _react.default.createElement(_When.default, {
    condition: !loading
  }, function () {
    return _react.default.createElement(_Layout.Flex, {
      padding: [4, 4, 5]
    }, _react.default.createElement(_DomestikaLiveCardInfo.DomestikaLiveCardInfo, {
      liveInfo: liveInfo,
      fontColor: "dark",
      size: "small",
      type: "basic"
    }));
  }));
};

exports.DomestikaSimpleLiveCard = DomestikaSimpleLiveCard;
DomestikaSimpleLiveCard.defaultProps = {
  liveInfo: {},
  loading: false,
  onClick: null,
  width: ['100%', '288px', '375px', '480px'],
  height: 'auto'
};